export const logToConsole = (html) => {
  const initalHtml = document.querySelector('#console').innerHTML;
  document.querySelector('#console').innerHTML = html + initalHtml;
}


// WEBPACK FOOTER //
// ./reproducer-custom-element/src/utils.js